const passwordStrengthPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/

export const PasswordStrengthValidator = {
  validate: (pw: string) => {
    return passwordStrengthPattern.test(pw)
  },
}
